import styled, { css } from 'styled-components';

import { Media } from '../../assets/Mixins.style';

import {
  Inputbox as commonInputbox,
  Input as commonInput,
} from '../../assets/Common/Inputbox.style';

import { Button as commonButton } from '../../assets/Common/Button.style';

export const Form = styled.form``;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 823px;
  max-width: 90vw;
  min-height: 331px;
  overflow: auto;
  padding: 25px;

  &::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background: ${(props) => props.theme.thumb};
  }

  &::-webkit-scrollbar-track {
    background: ${(props) => props.theme.track};
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 100%;
  padding: 0 0 20px;
  border-bottom: 1px solid ${(props) => props.theme.border};
`;

export const Title = styled.h2`
  display: inline-block;
  color: ${(props) => props.theme.color};
  font-size: 26px;
  font-weight: 600;
  text-align: center;
  cursor: default;
`;

export const Content = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  flex-grow: 1;
  align-items: stretch;
`;

export const Footer = styled.div`
  display: inline-grid;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  grid-template-columns: auto auto;
  grid-gap: 15px;

  ${Media.sm`
    grid-template-columns: 1fr;
  `}
`;

export const Button = styled.button`
  ${commonButton}
  display: inline-flex;
  width: auto;
  min-width: 175px;
`;

export const Box = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const Row = styled.div`
  display: flex;
  align-items: flex-start;
  width: 100%;
  padding: 0 0 20px;
  border-bottom: 1px solid ${(props) => props.theme.border};

  &:last-of-type {
    border-bottom: 0;
  }

  ${(props) =>
    props.grow &&
    css`
      height: 100%;
    `}
`;

export const Textbox = styled.div`
  display: block;
  width: 100%;
  margin-top: 15px;
  margin-bottom: 25px;
  text-align: center;

  ${(props) =>
    props.center &&
    css`
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 100%;
    `}
`;

export const Text = styled.p`
  color: ${(props) => props.theme.color};
  font-size: 24px;
  font-weight: 400;
  line-height: 1.2;
  cursor: default;
`;

export const Item = styled.div`
  display: grid;
  width: 100%;
  padding: 10px;
  grid-gap: 15px;
  align-items: flex-start;

  ${(props) =>
    props.single &&
    css`
      max-width: 60%;
      margin: 0 auto;
    `}
`;

export const ItemInner = styled.div`
  display: block;
  width: 100%;
`;

export const SubtitleHolder = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;

  ${Media.md`
    flex-direction: column;
  `}
`;

export const Subtitle = styled.h3`
  display: block;
  margin-bottom: 10px;
  color: ${(props) => props.theme.color};
  font-size: 16px;
  font-weight: 700;
  text-align: left;
  cursor: default;
`;

export const InputboxHolder = styled.div`
  display: grid;
  width: 100%;
  grid-gap: 15px;
`;

export const Inputbox = styled.div`
  ${commonInputbox}
`;

export const Input = styled.input`
  ${commonInput}
`;

export const Link = styled.a`
  display: inline-flex;
  align-items: center;
  margin: 0 0 0 auto;
  color: ${(props) => props.theme.color};
  font-size: 18px;
  font-weight: 400;
  cursor: pointer;
`;

export const Icon = styled.i`
  font-size: inherit;
`;
